"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryIrisMintingInfation = void 0;
const chain_query_1 = require("../../chain-query");
class ObservableQueryIrisMintingInfation extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, "/mint/params");
    }
}
exports.ObservableQueryIrisMintingInfation = ObservableQueryIrisMintingInfation;
//# sourceMappingURL=iris-minting.js.map